import { projectStatus } from "@planzone/dto";
import { Boundaries } from "@planzone/core";
import { State } from "./types";

function handleRetrieveZoneGantt(
  state: State,
  { gantt }: Boundaries["retrieveZoneGantt"]["success"],
): State {
  // const indexes = gantt.projects.map((project) => ({
  //   project,
  //   index: state.gantt.projects.findIndex(({ uuid }) => uuid === project.uuid),
  // }));
  //
  // return {
  //   ...state,
  //   gantt: {
  //     projects: indexes.reduce(
  //       (projects, { project, index }) =>
  //         index !== -1
  //           ? [
  //               ...projects.slice(0, index),
  //               { ...projects[index], ...project },
  //               ...projects.slice(index + 1),
  //             ]
  //           : [...projects, project],
  //       state.gantt.projects.map((p) => ({
  //         ...p,
  //         status: p.status ? p.status : { ...projectStatus, uuid: "" },
  //       })),
  //     ),
  //     constraints: [...state.gantt.constraints, ...gantt.constraints],
  //   },
  // };

  return state;
}

export { handleRetrieveZoneGantt };
